import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductBaseInfoFragment = { id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean };

export const ProductBaseInfoFragmentDoc = gql`
    fragment ProductBaseInfoFragment on ProductType {
  id
  pk
  name
  sku
  isInFavorites
  isShippingRequired
  isOutOfStock
}
    `;